import { Navigate } from 'react-router-dom';
import { PermissionGuard } from '../auth/PermissionGuard';
import { useCanAccessFeature } from '../../hooks/usePermissions';
import { TeamTab } from '../collaborators/TeamTab';
import { PermissionsTab } from './PermissionsTab';
import { TocSection } from './SettingsToc';

/** Paramètres › Équipe : les membres, puis ce que chaque rôle peut faire. Chaque partie garde son droit. */
export function TeamSettingsTab() {
  const first = useCanAccessFeature('settings_team');
  const second = useCanAccessFeature('settings_permissions');
  // Aucun des deux droits : la page n'a rien à montrer.
  if (!first && !second) return <Navigate to="/dashboard" replace />;

  return (
    <div className="space-y-12">
      <PermissionGuard feature="settings_team" fallback={null}>
        <TocSection label="Membres">
          <TeamTab />
        </TocSection>
      </PermissionGuard>
      <PermissionGuard feature="settings_permissions" fallback={null}>
        <TocSection label="Permissions">
          <PermissionsTab />
        </TocSection>
      </PermissionGuard>
    </div>
  );
}
